import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { trainerAPI } from '../../services/api';

export const fetchTrainerDashboard = createAsyncThunk('trainer/fetchDashboard', async (_, { rejectWithValue }) => {
  try {
    const response = await trainerAPI.getDashboard();
    return response.data;
  } catch (error) {
    return rejectWithValue(error.response?.data?.message || 'Failed to fetch dashboard');
  }
});

export const fetchTrainerMembers = createAsyncThunk('trainer/fetchMembers', async (_, { rejectWithValue }) => {
  try {
    const response = await trainerAPI.getMembers();
    return response.data.data;
  } catch (error) {
    return rejectWithValue(error.response?.data?.message || 'Failed to fetch members');
  }
});

const trainerSlice = createSlice({
  name: 'trainer',
  initialState: {
    dashboard: null,
    members: [],
    loading: false,
    error: null,
  },
  reducers: {
    clearError: (state) => { state.error = null; },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchTrainerDashboard.fulfilled, (state, action) => { state.dashboard = action.payload; })
      .addCase(fetchTrainerMembers.fulfilled, (state, action) => { state.members = action.payload; });
  },
});

export const { clearError } = trainerSlice.actions;
export const selectTrainerDashboard = (state) => state.trainer.dashboard;
export const selectTrainerMembers = (state) => state.trainer.members;
export default trainerSlice.reducer;
